import React, {useEffect, useRef} from 'react';
import {Link, Outlet} from 'react-router-dom';
import Logo from "../../atoms/Logo";
import LogoStandAlone from "../../atoms/LogoStandAlone";
import {PageTransition} from "../PageTransition";
import {useAppDispatch} from "../../../hooks/useAppDispatch";
import {useAppSelector} from "../../../hooks/useAppSelector";
import useTrackPageViews from "../../../hooks/useTrackPageViews";
import {fetchNotificationsCount} from "../../../features/notifications/notification_slice";
import {EventNames, identifyUser, trackEvent} from "../../../analytics";
import Avatar from "../../../pages/community/components/atoms/Avatar";
import {useI18n} from "../../../i18n";

const PublicLayout = () => {
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.auth.user);
    const {t} = useI18n();


    // TODO: Check for redundancy and remove if not needed
    useTrackPageViews();

    useEffect(() => {
        dispatch(fetchNotificationsCount());
    }, [dispatch]);

    useEffect(() => {
        // Check if user is logged in
        if (user) {
            // Identify user in Mixpanel
            identifyUser({
                uuid: user.uuid,
                id: user.id,
                email: user.email,
                is_premium: user.is_premium,
                plan_type: user.plan_type,
                is_affiliate: user.is_affiliate,
                referral_code: user.referral_code,
                first_name: user.first_name,
                last_name: user.last_name,
                created_at: user.created_at,
                created: user.createdAt,
                last_login: new Date(),
            });
        } else {
            // Track anonymous users
            trackEvent(EventNames.ANONYMOUS_USER_CREATED, {
                message: 'Anonymous user created',
                time: new Date(),
            });
        }
    }, [user]);
    return (
        <div className="flex flex-col min-h-screen bg-BLACK text-white">
            {/* Header */}
            <header className="w-full border-b border-neutral-800 bg-neutral-900">
                <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">

                    <LogoStandAlone />

                    { user ? (
                        <Link
                           to="/home"
                            className="flex items-center justify-center gap-2 text-sm bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-full"
                        >
                           <Avatar src={user?.avatar} size={25} /> {t('public.layout.gotoDashboard')}
                        </Link>
                    ) : <Link
                        to="/register"
                        className="text-sm bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-full"
                        onClick={() => trackEvent(EventNames.PUBLIC_SIGNUP_CLICKED)}
                    >
                        {t('common.signUp')}
                    </Link>}
                </div>
            </header>

            {/* Main content */}
            <main className="flex-grow w-full max-w-5xl mx-auto px-4 py-8">
                <PageTransition>
                    <Outlet/>
                    {/* CTA */}
                    {!user && <div className="mt-10 text-center">
                        <p className="text-gray-400 text-sm">{t('public.layout.createSetlistsPrompt')}</p>
                        <a
                            href="/register"
                            className="inline-block mt-2 px-4 py-2 bg-orange-500 text-white text-sm rounded-full
                     hover:bg-orange-600"
                            onClick={() => trackEvent(EventNames.PUBLIC_SIGNUP_CLICKED)}
                        >
                            {t('common.signUp')}
                        </a>
                    </div>}
                </PageTransition>
            </main>

            {/* Footer */}
            <footer className="w-full border-t border-neutral-800 bg-neutral-900">
                <div
                    className="max-w-7xl mx-auto px-4 py-6 text-sm text-gray-500 flex flex-wrap justify-between items-center">
                    <span>{t('public.layout.copyright', {year: new Date().getFullYear()})}</span>
                    <div className="space-x-4">
                        <Link to="/about" className="hover:underline">{t('public.layout.about')}</Link>
                        <Link to="/privacy" className="hover:underline">{t('public.layout.privacy')}</Link>
                        <Link to="/terms" className="hover:underline">{t('public.layout.terms')}</Link>
                        <Link to="/contact" className="hover:underline">{t('public.layout.contact')}</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PublicLayout;
